<template>
  <select-dialog
    ref="selectDialog"
    :title="title"
    :row-data="rowData"
    :column-defs="columnDefs"
    :filter-keys="['name', 'documentTypeUuidStr']"
    :value="finalBatchTemplateUuid"
    :event-name="eventName"
    :display-name-field="displayNameField"
    :show-office="true"
    @change="changeTrigger"
    @selected="selectedHandle"
  />
</template>

<script>
import {
  INSTRUCTION_BATCH_TEMPLATE_TYPE_MAP,
  SE
} from '@/class/cargo/model/parameters/SystemConstants'
import SelectDialog from '@/components/SelectDialog'

export default {
  name: 'BatchTemplateManagementDialog',
  components: { SelectDialog },
  props: {
    lob: {
      type: String,
      default: () => SE.code
    },
    bachDocumentTypeUuid: { // 选中的文件类型
      type: String,
      default: () => ''
    },
    batchTemplateUuid: { // 选中的模板
      type: String,
      default: () => ''
    },
    templates: { type: Array, default: () => [] }, //
    selectFileType: { // true-选中的文件类型 false-选择模板
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.AdditionalOutputAssociatedTemplate'),
          field: 'coverTemplateUuidStr',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.FileClassification'),
          field: 'documentTypeUuidStr',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateFileCloudStorageID'),
          cellRenderer: params => {
            if (params.data.engine !== 1 && params.data.engine !== 2) {
              return params.data.documentId
            }
            if (params.data.documentId) {
              return `<u onclick="document.templateManage.editReport('${params.data.uuid}')" style="cursor:pointer">${params.data.documentId}</u>`
            } else {
              return `<u onclick="document.templateManage.createReport('${params.data.uuid}')" style="cursor:pointer">${this.$t('SystemMaintenance.CreateTemplate')}</u>`
            }
          },
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateEngine'),
          field: 'engineStr',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.FilterScript'),
          field: 'filter',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateName'),
          field: 'name',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.BranchSerialNumber'),
          field: 'officeIdStr',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.Remark'),
          field: 'remarks',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateFile'),
          field: 'templateFile',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateSerialNumber'),
          field: 'templateId',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateClass'),
          field: 'templateType',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateUsage'),
          field: 'templateUsageStr',
          width: 100
        }
      ],
      eventName: '',
      displayNameField: '',
      batchFileTypeTemplate: {}
    }
  },
  computed: {
    finalBatchTemplateUuid() {
      return this.selectFileType ? this.batchFileTypeTemplate.uuid : this.batchTemplateUuid
    },
    title() {
      return this.selectFileType ? this.$t('CargoMsg.Cargo_SelectPrintFileType') : this.$t('CargoMsg.Cargo_SelectPrintFileTemplate')
    }
  },
  watch: {
    selectFileType() {
      if (this.selectFileType) {
        this.displayNameField = 'documentTypeUuidStr'
      } else {
        this.displayNameField = 'name'
      }
      this.eventName = ''
      this.batchFileTypeTemplate = {}
      if (this.$refs.selectDialog) {
        this.$refs.selectDialog.onReset()
      }
    },
    bachDocumentTypeUuid() {
      if (!this.bachDocumentTypeUuid) {
        this.eventName = ''
        this.batchFileTypeTemplate = {}
        if (this.$refs.selectDialog) {
          this.$refs.selectDialog.onReset()
        }
      } else {
        const batchFileTypeTemplate = this.rowData.find(item => item.documentTypeUuid === this.bachDocumentTypeUuid)
        if (batchFileTypeTemplate) {
          this.eventName = batchFileTypeTemplate.documentTypeUuidStr
          this.batchFileTypeTemplate = batchFileTypeTemplate
        }
      }
    },
    batchTemplateUuid() {
      if (!this.batchTemplateUuid) {
        this.eventName = ''
        this.batchFileTypeTemplate = {}
        if (this.$refs.selectDialog) {
          this.$refs.selectDialog.onReset()
        }
      }
    }
  },
  created() {
    this.rowData = []
    this.eventName = ''
    if (this.selectFileType) {
      this.displayNameField = 'documentTypeUuidStr'
    } else {
      this.displayNameField = 'name'
    }
    if (this.templates && this.templates.length > 0) {
      this.rowData = this.templates.filter(p => {
        return p.templateType && INSTRUCTION_BATCH_TEMPLATE_TYPE_MAP.get(this.lob) === p.templateType.trim()
      })
      if (this.rowData && this.rowData.length > 0) {
        if (this.selectFileType) {
          if (this.bachDocumentTypeUuid) {
            const batchFileTypeTemplate = this.rowData.find(item => item.documentTypeUuid === this.bachDocumentTypeUuid)
            if (batchFileTypeTemplate) {
              this.eventName = batchFileTypeTemplate.documentTypeUuidStr
              this.batchFileTypeTemplate = batchFileTypeTemplate
            }
          }
        } else {
          if (this.batchTemplateUuid) {
            const batchTemplate = this.rowData.find(item => item.uuid === this.batchTemplateUuid)
            if (batchTemplate) {
              this.eventName = batchTemplate.name
            }
          }
        }
      }
    }
  },
  methods: {
    changeTrigger(data) {
      this.$emit('change', data)
    },
    selectedHandle(data) {
      if (this.selectFileType && !data.documentTypeUuid) {
        this.$message.error(this.$t('CargoMsg.Cargo_SelectPrintFileTypeTip'))
      }
    }
  }
}
</script>
